var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.checkInput,"paste":_vm.checkInput,"focus":function($event){return _vm.$emit('focus')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }